module.exports = __webpack_public_path__ + "static/media/sauvegarde.6e2e2157.mp3";